import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import ResetPassword from '@auth/ResetPassword';
import ChangePassword from '@auth/ChangePassword';
import Signup from '@auth/Signup';
import SignIn from '@auth/SignIn';
import EmailSent from '@auth/EmailSent';
import Sellers from '@app/sellers';
import Product from '@app/product';
import { Toaster } from 'react-hot-toast';
import OTP from '@app/auth/OTP';
import './index.css';
import { AppStyle } from '@design-system/AppStyle/AppStyle';
import Password from '@app/profile/changePassword';
import MarketPlace from '@app/marketplace';
import Help from '@app/help';
import Profile from '@app/profile';
import Basket from '@app/basket';
import BasketCart from '@app/basketDetails';
import Logout from '@app/logout';
import OrderSuccess from '@app/orderSuccess';
import OrderHistory from '@app/orderHistory';
import Home from '@app/home';

function App() {
  return (
    <BrowserRouter>
      <AppStyle>
        <div>
          <Toaster />
        </div>
        <Switch>
          <Route path="/new-password">
            <ResetPassword />
          </Route>
          <Route path="/reset-password">
            <ChangePassword />
          </Route>

          <Route path="/change-password">
            <Password />
          </Route>
          <Route path="/home">
            <Home />
          </Route>

          <Route path="/signup">
            <Signup />
          </Route>
          <Route path="/login">
            <SignIn />
          </Route>
          <Route path="/logout">
            <Logout />
          </Route>

          <Route path="/emailsent">
            <EmailSent />
          </Route>
          <Route path="/otp">
            <OTP />
          </Route>
          <Route exact path="/help">
            <Help />
          </Route>
          <Route exact path="/marketplace">
            <MarketPlace />
          </Route>
          <Route exact path="/settings/:id">
            <Profile />
          </Route>
          <Route exact path="/basket">
            <Basket />
          </Route>
          <Route exact path="/shipping/:id">
            <BasketCart />
          </Route>

          <Route exact path="/sella/:id">
            <Sellers />
          </Route>
          <Route exact path="/partner/:id">
            <Sellers />
          </Route>
          <Route exact path="/products/:id">
            <Product />
          </Route>
          <Route exact path="/order/success/:id">
            <OrderSuccess />
          </Route>
          <Route exact path="/order/:id">
            <OrderHistory />
          </Route>
          <Route exact path="/">
            <Redirect to="/home" replace />
          </Route>
        </Switch>
      </AppStyle>
    </BrowserRouter>
  );
}

export default App;
